import { Department } from '@/plugins/api'

export default {
  namespaced: true,

  state: {
    departments: [],
    department: null,
    loading: false,
    error: null
  },

  mutations: {
    SET_DEPARTMENTS(state, departments) {
      state.departments = departments
    },
    SET_DEPARTMENT(state, department) {
      state.department = department
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },

  actions: {
    async fetchDepartments({ commit }, params) {
      commit('SET_LOADING', true)
      try {
        const response = await Department.fetch(params)
        commit('SET_DEPARTMENTS', response)
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchDepartment({ commit }, id) {
      commit('SET_LOADING', true)
      try {
        const response = await Department.fetchOne(id)
        commit('SET_DEPARTMENT', response)
      } catch (error) {
        commit('SET_ERROR', error.message)
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createDepartment({ commit }, params) {
      commit('SET_LOADING', true)
      try {
        const response = await Department.create(params)
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateDepartment({ commit }, { id, params }) {
      commit('SET_LOADING', true)
      try {
        const response = await Department.update(id, params)
        return response
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async deleteDepartment({ commit }, id) {
      commit('SET_LOADING', true)
      try {
        await Department.remove(id)
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },

  getters: {
    getDepartments: state => state.departments,
    getDepartment: state => state.department,
    isLoading: state => state.loading,
    getError: state => state.error
  }
}
